import { getRealNameAuthResult } from "@/api/theApi";
import { Toast } from "vant";

export const getInviteUrlByEnv = () => {
  return `${window.location.origin}${process.env.BASE_URL}regLogin`;
};

/**
 * 从url的query参数中获取 BizToken
 */
export const getBizTokenFromUrl = () => {
  const url = new URL(window.location.href);
  return url.searchParams.get("BizToken");
};

/**
 * 从url的query参数中移除 BizToken
 */
export const removeBizTokenFromUrl = () => {
  try {
    const url = new URL(window.location);
    url.searchParams.delete("BizToken");

    // 使用replaceState替换当前历史记录，不会创建新的页面栈
    window.history.replaceState({}, "", url.toString());
    console.log("已从URL中移除BizToken参数");
  } catch (error) {
    console.error("移除URLBizToken参数时发生错误:", error);
  }
};

/**
 * 上报BizToken
 */
export const reportBizToken = async (bizToken) => {
  if (bizToken && localStorage.getItem("username")) {
    try {
      const res = await getRealNameAuthResult(bizToken);
      if (res.code === 20000 && res.data === 'true') {
        console.log("实名认证结果:", res.data);
        Toast.success("实名认证成功");
      } else {
        console.log("实名认证结果:", res.msg);
        Toast.fail("实名认证失败");
      }
      removeBizTokenFromUrl();
    } catch (error) {
      console.error("实名认证请求失败:", error);
      Toast.fail("实名认证请求失败，请稍后重试");
    }
  } else {
    console.log("URL中未发现BizToken参数");
  }
};

/**
 * 处理BizToken
 */
export const dealBizToken = async () => {
  const bizToken = getBizTokenFromUrl();
  if (bizToken && localStorage.getItem("username")) {
    await reportBizToken(bizToken);
  } else {
    console.log("URL中未发现BizToken参数");
  }
};
